export const CATEGORY_DATA = {
  PU: { category: "Pouch" /* ... */ },
  HP: { category: "Hath Phul" /* ... */ },
  LT: { category: "Lock Type" /* ... */ },
  CDPD: { category: "Initial Pendant" /* ... */ },
  VPTR: { category: "Trouser" /* ... */ },
  SDER: { category: "Diamond Earrings" /* ... */ },
  SDR: { category: "Diamond Rings" /* ... */ },
  SDPD: { category: "Diamond Pendant" /* ... */ },
  GDCH: { category: "Gold Chain" /* ... */ },
  MT: { category: "Maang Tika" /* ... */ },
  VPSH: { category: "Shirt" /* ... */ },
  GDLSH: { category: "Gold and Diamond Shank for Solitaire Ring" /* ... */ },
  VPBL: { category: "Blazer" /* ... */ },
  GDLBBBR: { category: "Buy Back Lab Grown Diamond Bracelet" /* ... */ },
  SDLR: { category: "Lab-grown Diamond Rings" /* ... */ },
  EX: { category: "Extender" /* ... */ },
  TEST: { category: "TEST" /* ... */ },
  SDLER: { category: "Lab-grown Diamond Earrings" /* ... */ },
  MI_: { category: "MI Coin" /* ... */ },
  GDLHE: { category: "Gold and Diamond Head for Solitaire Ring" /* ... */ },
  JO: { category: "Jewellery Organiser" /* ... */ },
  BH: { category: "Brooch" /* ... */ },
  WC: { category: "Watch Charm" /* ... */ },
  VPJA: { category: "Jacket" /* ... */ },
  GC: { category: "Gift Card" /* ... */ },
  FREEGIFT: { category: "Free Gift" /* ... */ },
  CF: { category: "Cufflinks" /* ... */ },
  GW: { category: "Gift Wrap" /* ... */ },
  GDLBBPD: { category: "Buy Back Lab Grown Diamond Pendant" /* ... */ },
  PL: { category: "Plate" /* ... */ },
  TP: { category: "Tie Pin" /* ... */ },
  SDLPD: { category: "Lab-grown Diamond Pendants" /* ... */ },
  CO: { category: "Coin" /* ... */ },
  GDTEST: { category: "Gold Test" /* ... */ },
  BCH: { category: "Bulk Chain" /* ... */ },
  CHEM: { category: "Chemical" /* ... */ },
  GDBR: { category: "Gold Bracelet" /* ... */ },
  PR: { category: "Perfume" /* ... */ },
  PFSET: { category: "Photo Frame Combo" /* ... */ },
  GDLBBNP: { category: "Buy Back Lab Grown Diamond Nose Pins" /* ... */ },
  GDLBBR: { category: "Buy Back Lab Grown Diamond Ring" /* ... */ },
  GDLBBER: { category: "Buy Back Lab Grown Diamond Earrings" /* ... */ },
  GDLBBNE: { category: "Buy Back Lab Grown Diamond Necklace" /* ... */ },
  VDGPD: { category: "Non Studded Pendant" /* ... */ },
  VDGNE: { category: "Non Studded Necklace" /* ... */ },
  VDGMN: { category: "Non Studded Mangalsutra" /* ... */ },
  VDGBR: { category: "Non Studded Bracelet" /* ... */ },
  VDGCH: { category: "Non Studded Chains" /* ... */ },
  VDSPD: { category: "Silver Pendant" /* ... */ },
  VDSNE: { category: "Silver Necklace" /* ... */ },
  VDSMN: { category: "Silver Mangalsutra" /* ... */ },
  VDSER: { category: "Silver Earring" /* ... */ },
  VDSR: { category: "Silver Rings" /* ... */ },
  VDSBR: { category: "Silver Bracelet" /* ... */ },
  VDSCH: { category: "Silver Chains" /* ... */ },
  CA: { category: "Candles" /* ... */ },
  GDLBBMN: { category: "Buyback Lab Grown Diamond Gold Mangalsutra" /* ... */ },
  VDGER: { category: "Non Studded Earring" /* ... */ },
  VDGR: { category: "Non Studded Rings" /* ... */ },
  NE: { category: "Necklace" /* ... */ },
  PF: { category: "Photo Frame" /* ... */ },
  PER: { category: "Piercing Earring" /* ... */ },
  ID: { category: "idol" /* ... */ },
  UT: { category: "Utensils" /* ... */ },
  KER: { category: "Kids Earring" /* ... */ },
  KR: { category: "Kids Rings" /* ... */ },
  CR: { category: "Charms" /* ... */ },
  PX: { category: "Personalised" /* ... */ },
  NP: { category: "Nosepin" /* ... */ },
  HA0: { category: "Hair Accessories" /* ... */ },
  VP: { category: "VM Props" /* ... */ },
  VDSGR: { category: "Studded Rings" /* ... */ },
  VDSGBR: { category: "Studded Bracelet" /* ... */ },
  VDSGPD: { category: "Studded Pendant" /* ... */ },
  VDSGMN: { category: "Studded Mangalsutra" /* ... */ },
  VDSGNE: { category: "Studded Necklace" /* ... */ },
  VDSGER: { category: "Studded Earring" /* ... */ },
  GDCO: { category: "Gold Coin" /* ... */ },
  GDLBR: { category: "Lab-Grown Gold Diamond Bracelet" /* ... */ },
  GDLPD: { category: "Lab-grown Gold Diamond Pendant" /* ... */ },
  GDLNE: { category: "Lab Grown Diamond and Gold Necklace" /* ... */ },
  KBR: { category: "Kids Bracelet" /* ... */ },
  KPD: { category: "Kids Pendant" /* ... */ },
  RK: { category: "Rakhis" /* ... */ },
  AV: { category: "Oxidised Silver" /* ... */ },
  TR: { category: "Toe Rings" /* ... */ },
  CH: { category: "Chains" /* ... */ },
  PM: { category: "Packaging Material" /* ... */ },
  FER: { category: "Finding for Earring" /* ... */ },
  MER: { category: "Men's Earrings" /* ... */ },
  GDPD: { category: "Non Studded Pendant" /* ... */ },
  GDNE: { category: "Non Studded Necklace" /* ... */ },
  GDMN: { category: "Non Studded Mangalsutra" /* ... */ },
  GDER: { category: "Non Studded Earring" /* ... */ },
  GDR: { category: "Non Studded Rings" /* ... */ },
  FI: { category: "Findings" /* ... */ },
  KA: { category: "Kids Anklets" /* ... */ },
  ER: { category: "Earrings" /* ... */ },
  A: { category: "Anklets" /* ... */ },
  PD: { category: "Pendant" /* ... */ },
  GDLER: { category: "Lab-grown Gold Diamond Earring" /* ... */ },
  BR: { category: "Bracelet" /* ... */ },
  GDLMN: { category: "Lab-grown Gold Diamond Mangalsutra" /* ... */ },
  BB: { category: "B2B" /* ... */ },
  GDLNP: { category: "Lab Grown Diamond Nose Pins" /* ... */ },
  GDLR: { category: "Lab-grown Gold Diamond Ring" /* ... */ },
  R: { category: "Rings" /* ... */ },
  GDMT: { category: "Gold MTO" /* ... */ },
  OMR: { category: "Onnme Ring" /* ... */ },
  OMPD: { category: "Onnme Pendant" /* ... */ },
  OMA: { category: "Onnme Anklets" /* ... */ },
  OMWC: { category: "Onnme Watch Charm" /* ... */ },
  OMPH: { category: "Onnme Photo Frame" /* ... */ },
  OMBR: { category: "Onnme Brooch" /* ... */ },
  OMNE: { category: "Onnme Necklace" /* ... */ },
  OMCH: { category: "Onnme Chains" /* ... */ },
  OMHA: { category: "Onnme Hair Accessories" /* ... */ },
};
